<template>


  <div>
    <div class="md:grid md:grid-cols-3 md:gap-6">
      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            Frageart
          </h3>
          <p class="mt-1 text-sm leading-5 text-gray-600"></p>
        </div>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <div class="shadow sm:rounded-md sm:overflow-hidden">

          <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-6 sm:col-span-4">

                <div v-if="questionTypes" class="flex items-center justify-between">

                  <div class="flex items-center space-x-4 w-2/3">
                    <select v-model="question_type" :disabled="processing" @change="question_type = $event.target.value"
                      class="mt-0 block py-2 pl-3 pr-8 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-400 focus:border-gray-400 sm:text-sm">
                      <option value="">-- bitte wählen --</option>
                      <option v-for="question_type in questionTypes" :value="question_type.id" :key="question_type.id"
                        :selected="question_type.id == question_type">
                        {{ question_type.name }}
                      </option>
                    </select>

                    <p class="text-sm">{{ liveResultType }}</p>
                  </div>

                  <div class="w-1/3 flex items-center space-x-2">
                    <select v-model="classification_type" :disabled="processing"
                      @change="classification_type = $event.target.value"
                      class="mt-0 block py-2 pl-3 pr-8 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-400 focus:border-gray-400 sm:text-sm">
                      <option value="">-- bitte wählen --</option>
                      <option v-for="classificationType in classificationTypes" :value="classificationType.id"
                        :key="classificationType.id" :selected="classificationType.id == classification_type">
                        {{ classificationType.name }}
                      </option>
                    </select>

                    <svg xmlns="http://www.w3.org/2000/svg"
                      v-tooltip="`Diese Angabe bestimmt, wie Josefa mit der Verortung der Antworten umgeht. 'Text'-Fragen werden mit von GPT erzeugten Worten erweitert, während 'Schlagwort'-Fragen keinen GPT-Prozess durchlaufen. Dies ist ein Pflichtfeld.`"
                      fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                      class="w-5 h-5 text-gray-400">
                      <path stroke-linecap="round" stroke-linejoin="round"
                        d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                    </svg>

                  </div>
                </div>


                <!-- parameters keywords: start -->
                <div v-if="question_type == 'keywords'" class="mt-5 w-full flex items-center justify-between">

                  <div class="w-1/2">
                    <label for="keywords_keywords" class="block text-sm font-medium leading-5 text-gray-700 mt-5">Anzahl
                      Schlagworte</label>
                    <select v-model="parameters.keywords.keywords" :disabled="processing"
                      @change="parameters.keywords.keywords = $event.target.value"
                      class="mt-1 w-1/3 block py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-400 focus:border-gray-400 sm:text-sm">
                      <option v-for="idx in 6" :value="idx" :key="idx">
                        {{ idx }}
                      </option>
                    </select>

                  </div>
                  <div class="w-1/2">

                    <label for="keywords_placeholder"
                      class="block text-sm font-medium leading-5 text-gray-700 mt-5">Platzhalter (z.B. "Ein
                      Wort")</label>
                    <input type="text" id="keywords_placeholder" v-model="parameters.keywords.placeholder"
                      :disabled="processing"
                      class="mt-1 w-full focus:ring-gray-400 focus:border-gray-400 block  sm:text-sm border-gray-300 rounded-md" />
                  </div>

                </div>
                <!-- parameters keywords: end -->


                <!-- parameters multiple textareas: start -->
                <div v-if="question_type == 'textblock_multiple'" class="mt-5 w-full flex items-center justify-between">

                  <div class="w-1/2">
                    <label for="textblock_multiple_max_answers"
                      class="block text-sm font-medium leading-5 text-gray-700 mt-5">Max. Antworten</label>
                    <select v-model="parameters.textblock_multiple.max_answers" :disabled="processing"
                      @change="parameters.textblock_multiple.max_answers = $event.target.value"
                      class="mt-1 w-1/3 block py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-400 focus:border-gray-400 sm:text-sm">
                      <option v-for="idx in 6" :value="idx" :key="idx">
                        {{ idx }}
                      </option>
                    </select>

                  </div>
                  <div class="w-1/2">


                  </div>

                </div>
                <!-- parameters multiple textareas: end -->


                <!-- parameters multiple choice: start -->
                <div v-if="question_type == 'choices'" class="mt-5 w-full flex flex-col items-center justify-between">

                  <div class="w-full flex items-center">

                    <div class="w-3/12">
                      <label for="choices_num_choices"
                        class="block text-sm font-medium leading-5 text-gray-700 mt-5">Anzahl Optionen</label>
                      <select v-model="parameters.choices.num_choices" :disabled="processing"
                        @change="parameters.choices.num_choices = $event.target.value"
                        class="mt-1 w-2/3 block py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-400 focus:border-gray-400 sm:text-sm">
                        <option v-for="idx in 10" :value="idx" :key="idx">
                          {{ idx }}
                        </option>
                      </select>

                    </div>
                    <div class="w-3/12">
                      <label for="choices_multiple_answers"
                        class="block text-sm font-medium leading-5 text-gray-700 mt-5">Multiple Choice</label>
                      <select v-model.number="parameters.choices.multiple_answers" :disabled="processing"
                        class="mt-1 w-2/3 block py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-400 focus:border-gray-400 sm:text-sm">
                        <option :value="1" key="1">Ja</option>
                        <option :value="0" key="0">Nein</option>
                      </select>

                    </div>

                  </div>


                  <div class="w-full flex flex-col space-y-3 items-start">
                    <label for="choices_choices"
                      class="block text-sm font-medium leading-5 text-gray-700 mt-5">Optionen</label>

                    <input v-for="idx in parseInt(parameters.choices.num_choices)" :key="`choices_choice_${idx}`"
                      type="text" :id="`choices.choices_${idx}`" v-model="parameters.choices.choices[idx - 1]"
                      :disabled="processing" :placeholder="`Option ${idx}`"
                      class="mt-1 w-9/12 focus:ring-gray-400 focus:border-gray-400 block  sm:text-sm border-gray-300 rounded-md" />
                  </div>


                  <div class="w-full flex items-center">

                    <div class="w-2/12">
                      <label for="choices_has_other"
                        class="block text-sm font-medium leading-5 text-gray-700 mt-5">Sonstiges</label>
                      <select v-model="parameters.choices.has_other" :disabled="processing"
                        @change="parameters.choices.has_other = $event.target.value"
                        class="mt-1 w-2/3 block py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-400 focus:border-gray-400 sm:text-sm">
                        <option value="1" key="1">Ja</option>
                        <option value="0" key="0">Nein</option>
                      </select>

                    </div>
                    <div class="w-6/12">
                      <div v-if="parameters.choices.has_other == 1" class="w-full">
                        <label for="choices_other_label"
                          class="block text-sm font-medium leading-5 text-gray-700 mt-5">Label, z.B. "Sonstiges"</label>
                        <input type="text" id="choices.other_label" v-model="parameters.choices.other_label"
                          :disabled="processing"
                          class="mt-1 w-full focus:ring-gray-400 focus:border-gray-400 block  sm:text-sm border-gray-300 rounded-md" />

                      </div>
                    </div>
                  </div>

                </div>
                <!-- parameters multiple choice: end -->



                <!-- parameters rating: start -->
                <div v-if="question_type == 'rating'" class="mt-5 w-full flex items-center justify-between">

                  <div class="w-1/2">
                    <label for="rating_max" class="block text-sm font-medium leading-5 text-gray-700 mt-5">1
                      bis n</label>
                    <select v-model="parameters.rating.max" :disabled="processing"
                      @change="parameters.rating.max = $event.target.value"
                      class="mt-1 w-1/3 block py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-gray-400 focus:border-gray-400 sm:text-sm">
                      <option :value="10">10</option>
                      <option :value="5">5</option>
                    </select>

                  </div>
                  <div class="w-1/2">


                  </div>

                </div>
                <!-- parameters rating: end -->



              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {

  props: {
    question: Object,
    questionTypes: Array,
    processing: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      classificationTypes: [
        {
          id: 'keyword',
          name: 'Schlagwort',
        },
        {
          id: 'text',
          name: 'Text',
        },
      ],
      question_type: this.question?.question_type || '',
      classification_type: this.question?.classification_type || '',
      parameters: {
        keywords: {
          keywords: this.question?.question_type == 'keywords' ? this.question?.parameters.options.keywords : 3,
          placeholder: this.question?.question_type == 'keywords' ? this.question?.parameters.options.placeholder : '',
        },
        textblock_multiple: {
          max_answers: this.question?.question_type == 'textblock_multiple' ? this.question?.parameters.options.max_answers : 3,
        },
        choices: {
          num_choices: this.question?.question_type == 'choices'
            ? this.question?.parameters.options.num_choices
            : 3,

          has_other: this.question?.question_type == 'choices'
            ? this.question?.parameters.options.has_other
            : 0,

          other_label: this.question?.question_type == 'choices'
            ? this.question?.parameters.options.other_label
            : '',

          multiple_answers: this.question?.question_type == 'choices'
            ? (this.question?.parameters.options.multiple_answers ? 1 : 0)
            : 0,

          choices: this.question?.question_type == 'choices'
            ? this.question?.parameters.choices
            : [],
        },
        rating: {
          max: this.question?.question_type == 'rating' ? this.question?.parameters.options.max : 10,
        },
      },
    };
  },


  watch: {
    question_type: {
      handler: function () {
        this.$emit('questionTypeChanged', {
          question_type: this.question_type,
          classification_type: this.classification_type,
          parameters: this.parameters
        },);
      },
    },

    classification_type: {
      handler: function () {
        this.$emit('questionTypeChanged', {
          question_type: this.question_type,
          classification_type: this.classification_type,
          parameters: this.parameters
        },);
      },
    },

    parameters: {
      deep: true,
      handler: function () {
        this.$emit('questionTypeChanged', {
          question_type: this.question_type,
          classification_type: this.classification_type,
          parameters: this.parameters
        },);
      },
    },
  },

  methods: {
    placeholderQuestionChanged(question) {
      this.placeholder_question = question;
    },
  },

  computed: {
    liveResultType() {
      if (!this.question_type) {
        return '';
      }

      if (this.question_type == 'choices') {
        if (this.parameters?.choices?.multiple_answers == 1) {
          return 'Bar-Chart';
        }

        return 'Pie-Chart';
      }

      return this.questionTypes.filter((question_type) => {
        return question_type.id == this.question_type;
      })[0]?.live_results_type?.name || ''
        ;
    },
  },
};
</script>
